











import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class DateRange extends Vue {
  @Prop() value!: string;
  @Prop() label!: string;
  @Prop() rules!: unknown;
  lastValue = "";
  display = "";
  mounted() {
    this.setDisplay(this.value);
  }
  @Watch("value")
  onValueChange(newValue: string) {
    this.setDisplay(newValue);
  }
  onInput(value: string) {
    this.$emit("input", value);
  }
  setDisplay(value: string) {
    this.display = value;
  }
}
